import React, { Component } from 'react';

export default class DaySafetyElement extends Component {
  state = {
    hover: false,
  };

  setClicked = (value) => {
    this.setState({ clicked: false });
  };

  openInfo = (event) => {
    this.props.showInfo(this.props.num);
  };

  onMouseEnter = (event) => {
    this.setState({ hover: true });
  };

  onMouseLeave = (event) => {
    this.setState({ hover: false });
  };

  render() {
    let { num } = this.props;
    let { color } = this.props;
    let { issues } = this.props;
    // let element = elements[num];
    // console.log("this.props ", this.props);
    // console.log('Safety: num %d, lastClicked %d, lastGroupClicked %d, color %s, issue %s', num, this.props.lastClickedElement, this.props.lastGroupClicked, color, issues);
    return (
      <div
        title={num}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.openInfo}
        className={`${
          this.props.oneTypeIssue === true ? 'element-one-type-issue' : 'element'
        } element_safety_fac-${num} ${color} ${
          this.state.hover || (this.props.lastClickedElement == num && this.props.lastGroupClicked == 1) ? 'active' : ''
        }`}
      >
        {/* <div className="number">{element.number}</div> */}
        <div className="symbol" style={color == 'yellow_state' ? { color: 'black' } : undefined}>
          {num < 32 ? num : ''}
        </div>
        {/* <div className="element-name">{element.name}</div> */}
      </div>
    );
  }
}
